import { redirect, RouteObject } from 'react-router-dom'

import { AuthWrapper } from 'pages/Auth/AuthWrapper'
import { Menu } from '../pages/Panel/Menu/Menu'
import { Panel } from '../pages/Panel/Panel'
import { Invoice } from 'pages/Panel/Menu/Invoice/Invoice'

// Описание возможных переходов со старницы с главным меню - компонент Panel.

export const wmsCargoRoutes: RouteObject[] = [
  {
    id: 'base',
    path: '/',
    loader: async () => redirect('/panel/menu'),
  },
  {
    id: 'login',
    path: '/login',
    Component: AuthWrapper,
  },
  {
    id: 'panel',
    path: '/panel',
    Component: Panel,
    children: [
      // Меню.
      {
        id: 'menu',
        path: '/panel/menu',
        Component: Menu,
      },
      // Загрузка квитанции
      {
        id: 'invoiceUpload',
        path: '/panel/invoice',
        Component: Invoice,
      },
    ],
  },
]
